import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from 'throttle-debounce';

import { isInViewPort } from './utils/isInViewPort';
import { trackClick, trackView } from './utils/tracking';

/**
 * Добавляет аналитику для статичного сео блока журнала
 */
export function useStaticSeoBlockAnalitics(): void {
  const [journalContainer, setJournalContainer] = useState<HTMLElement | null>(null);

  const timerRef = useRef<number | undefined>(undefined);

  const scrollListener = useMemo(
    () =>
      throttle(100, () => {
        if (journalContainer) {
          if (isInViewPort(journalContainer, 0.5)) {
            if (!timerRef.current) {
              timerRef.current = window.setTimeout(() => {
                window.removeEventListener('scroll', scrollListener);
                clearTimeout(timerRef.current);
                trackView();
              }, 0);
            }
          } else if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = undefined;
          }
        }
      }),
    [journalContainer],
  );

  const handleClickListener = useCallback((event: MouseEvent) => {
    const el = event.currentTarget as HTMLAnchorElement;
    trackClick(el.href);
  }, []);

  useEffect(() => {
    setJournalContainer(document.getElementById('JournalHighlights'));
  }, []);

  useEffect(() => {
    if (!journalContainer) {
      return;
    }

    journalContainer.querySelectorAll('a').forEach(link => link.addEventListener('click', handleClickListener));
    window.addEventListener('scroll', scrollListener);

    return () => {
      journalContainer.querySelectorAll('a').forEach(link => link.addEventListener('click', handleClickListener));
      window.removeEventListener('scroll', scrollListener);
    };
  }, [handleClickListener, journalContainer, scrollListener]);
}
